<br />
<div>
  <!-- add observation -->
  <button mat-flat-button color="primary" routerLink="/explorer-item-new/">
    Agregar observaciones
  </button>

  <!-- export template -->
  <button mat-flat-button color="primary" style="margin: 0 5px">
    Exportar plantilla
  </button>
  <!-- advance filter -->
  <button
    #bt
    mat-stroked-button
    (click)="fnOpenDialog(bt, 900)"
    matBadge="{{ badgeFilter }}"
    matBadgeColor="primary"
    style="background-color: #c4a1c0; color: #fff; float: right"
  >
    <mat-icon>tune</mat-icon> Filtros
  </button>
</div>

<!-- Filters -->
<div
  fxLayout="row wrap"
  fxLayoutAlign="space-between center"
  class="top-panel-control content-body"
>
  <!-- variety filter -->
  <mat-form-field fxFlex="12" appearance="outline">
    <mat-label>Variedad</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      aria-label="Number"
      matInput
      [formControl]="variety_control"
      [matAutocomplete]="auto1"
    />
    <button
      mat-button
      matSuffix
      aria-label="Arrow"
      *ngIf="!variety_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="variety_control.value"
      matSuffix
      mat-icon-button
      (click)="fnParamsDataChange({ p_variety_name: null }, 'p_variety_name')"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto1="matAutocomplete"
      panelWidth="24em"
      (optionSelected)="
        fnParamsDataChange(
          { p_variety_name: variety_control.value },
          'p_variety_name'
        )
      "
    >
      <mat-option
        *ngFor="let option of filteredOptionsVariety | async"
        [value]="option"
      >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- farmer filter -->
  <mat-form-field fxFlex="12" appearance="outline">
    <mat-label>Hogares</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      aria-label="Number"
      matInput
      [formControl]="farmer_control"
      [matAutocomplete]="auto3"
    />
    <button
      mat-button
      matSuffix
      aria-label="Arrow"
      *ngIf="!farmer_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="farmer_control.value"
      matSuffix
      mat-icon-button
      (click)="fnParamsDataChange({ p_farmer_name: null }, 'p_farmer_name')"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto3="matAutocomplete"
      panelWidth="24em"
      (optionSelected)="
        fnParamsDataChange(
          { p_farmer_name: farmer_control.value },
          'p_farmer_name'
        )
      "
    >
      <mat-option
        *ngFor="let option of filteredOptionsFarmer | async"
        [value]="option"
      >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- country filter -->
  <mat-form-field
    fxFlex="12"
    appearance="outline"
    *ngIf="filteredOptionsCountry | async as countryList"
  >
    <mat-label>País</mat-label>
    <mat-select
      [(ngModel)]="country_value"
      name="country_name"
      (selectionChange)="
        fnParamsDataChange({ p_country: country_value }, 'p_country')
      "
    >
      <mat-option value="Todos">Todos</mat-option>
      <mat-option *ngFor="let option of countryList.data" [value]="option">
        {{ option }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- is original -->
  <mat-form-field fxFlex="12" appearance="outline">
    <mat-label>Es original</mat-label>
    <mat-select
      [(ngModel)]="is_original_value"
      name="is_original_name"
      (selectionChange)="
        fnParamsDataChange(
          { p_is_original: is_original_value },
          'p_is_original'
        )
      "
    >
      <mat-option value="Todos">Todos</mat-option>
      <mat-option value="Si">Si</mat-option>
      <mat-option value="No">No</mat-option>
    </mat-select>
  </mat-form-field>
  <!-- is public -->
  <mat-form-field fxFlex="12" appearance="outline">
    <mat-label>Es publico</mat-label>
    <mat-select
      [(ngModel)]="is_public_value"
      name="is_public_name"
      (selectionChange)="
        fnParamsDataChange({ p_is_public: is_public_value }, 'p_is_public')
      "
    >
      <mat-option value="Todos">Todos</mat-option>
      <mat-option value="Si">Si</mat-option>
      <mat-option value="No">No</mat-option>
    </mat-select>
  </mat-form-field>
  <!-- creation date filter -->
  <mat-form-field fxFlex="12" appearance="outline">
    <mat-label>Fecha de creación</mat-label>
    <input
      matInput
      type="text"
      [matDatepicker]="pickerInit"
      name="observation_date_name"
      (dateChange)="fnSearchVarietyObservation()"
      [formControl]="observation_date_control"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerInit"></mat-datepicker-toggle>
    <mat-datepicker #pickerInit color="primary"></mat-datepicker>
  </mat-form-field>
  <!-- clear filter -->
  <button mat-stroked-button (click)="fnClearFilters()">
    <mat-icon>restart_alt</mat-icon> Reiniciar
  </button>
</div>
<!-- ============================================== -->
<div fxLayout="row" *ngIf="fnIsRole('ADMIN')">
  <label class="stats-label" fxLayout="row" *ngIf="statsObs | async as stats">
    Reporte: VarScout ({{ stats.data.vs_observation_count }}
    ) | Wikipapa (
    {{ stats.data.observation_count }}
    ) | Publicos (
    {{ stats.data.public_count }}
    ) | Privados (
    {{ stats.data.private_count }})
  </label>

  <button
    mat-button
    color="primary"
    title="Obtener datos estadisticos actualizados"
    (click)="fnGetStats()"
    [style.fontSize.px]="10"
  >
    Actualizar
  </button>

  <button
    mat-button
    color="primary"
    title="Sincronizar observaciones"
    (click)="fnSync()"
    [style.fontSize.px]="10"
  >
    Sincronizar
  </button>
</div>
<!-- ============================================== -->
<div fxLayout="row" *ngIf="fnIsRole('USER')">
  <label class="stats-label" fxLayout="row" *ngIf="statsObs | async as stats">
    Reporte: Públicos (
    {{ stats.data.public_count }}
    ) | Privados (
    {{ stats.data.private_count }})
  </label>

  <button
    mat-button
    color="primary"
    title="Obtener datos estadísticos actualizados"
    (click)="fnGetStats()"
    [style.fontSize.px]="10"
  >
    Actualizar
  </button>

  <button
    mat-button
    color="primary"
    title="Sincronizar observaciones"
    (click)="fnSync()"
    [style.fontSize.px]="10"
  >
    Sincronizar
  </button>
</div>
<!-- ============================================== -->
<div fxLayout="row" style="margin-top: 10px">
  <div fxFlex="70" style="padding: 5px">
    <mat-paginator
      [pageIndex]="page_control"
      [pageSize]="page_size_control"
      [length]="_length"
      [showFirstLastButtons]="_showFirstLastButtons"
      [pageSizeOptions]="_pageSizeOptions"
      (page)="handlePageEvent($event)"
      aria-label="Select page"
      style="margin-bottom: 3px"
    >
    </mat-paginator>
    <div fxLayout="column" fxLayoutAlign="space-between stretch">
      <div class="row-header">
        <div fxFlex="4"></div>
        <div fxFlex="4">
          <span>Id</span>
        </div>
        <div fxFlex="14">
          <span>Multimedia</span>
        </div>
        <div fxFlex="14">
          <span>Variedad</span>
        </div>
        <div fxFlex="14">
          <span>Usuario</span>
        </div>
        <div fxFlex="10">
          <span>Observado el</span>
        </div>
        <div fxFlex="12">
          <span>Lugar</span>
        </div>

        <div fxFlex="14">
          <span>Público</span>
        </div>

        <div fxFlex="14">
          <span>Acción</span>
        </div>
      </div>
      <div *ngFor="let cardContent of cardContentList">
        <app-template-row-edit-obs
          [cardContent]="cardContent"
          [route]="'observacion'"
          (deleteChange)="fnGoToView('/tablero/explorer-list-edit', paramsData)"
        ></app-template-row-edit-obs>
      </div>
    </div>
    <mat-paginator
      [pageIndex]="page_control"
      [pageSize]="page_size_control"
      [length]="_length"
      [showFirstLastButtons]="_showFirstLastButtons"
      [pageSizeOptions]="_pageSizeOptions"
      (page)="handlePageEvent($event)"
      aria-label="Select page"
      style="margin-bottom: 3px"
    >
    </mat-paginator>
  </div>
  <div fxFlex="30" style="padding: 5px">
    <div style="padding-bottom: 0.5em; display: flex; justify-content: end">
      <button
        mat-button
        color="warn"
        style="font-size: 10px"
        (click)="fnGetAllCoordinates()"
      >
        Ver todos
      </button>
    </div>
    <div *ngIf="gpsCoordinateList">
      <app-template-map
        *ngIf="gpsCoordinateList.length"
        [coordinate_list]="gpsCoordinateList"
        [height_value]="'450px'"
      >
      </app-template-map>
    </div>
  </div>
</div>
